// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2yZBG","inputWrap":"Table_inputWrap__tRhMk","col":"Table_col__awcNU","bmiTooltip":"Table_bmiTooltip__bh_76"};